var provider = function provider() {
  for (var _len = arguments.length, ranges = new Array(_len), _key = 0; _key < _len; _key++) {
    ranges[_key] = arguments[_key];
  }

  var inRange = function inRange(number, range) {
    return number > range[0] && number < range[1];
  };

  var surroundsRange = function surroundsRange(inner, outer) {
    return inner[0] >= outer[0] && inner[1] <= outer[1];
  };

  var identity = {};

  identity.distance = function (start, end) {
    start = identity.clampUp(start);
    end = identity.clampDown(end);
    var surroundedRanges = ranges.filter(function (r) {
      return surroundsRange(r, [start, end]);
    });
    var rangeSizes = surroundedRanges.map(function (r) {
      return r[1] - r[0];
    });
    return end - start - rangeSizes.reduce(function (total, current) {
      return total + current;
    }, 0);
  };

  var add = function add(value, offset) {
    return value instanceof Date ? new Date(value.getTime() + offset) : value + offset;
  };

  identity.offset = function (location, offset) {
    if (offset > 0) {
      var _ret = function () {
        var currentLocation = identity.clampUp(location);
        var offsetRemaining = offset;

        while (offsetRemaining > 0) {
          var futureRanges = ranges.filter(function (r) {
            return r[0] > currentLocation;
          }).sort(function (a, b) {
            return a[0] - b[0];
          });

          if (futureRanges.length) {
            var nextRange = futureRanges[0];
            var delta = nextRange[0] - currentLocation;

            if (delta > offsetRemaining) {
              currentLocation = add(currentLocation, offsetRemaining);
              offsetRemaining = 0;
            } else {
              currentLocation = nextRange[1];
              offsetRemaining -= delta;
            }
          } else {
            currentLocation = add(currentLocation, offsetRemaining);
            offsetRemaining = 0;
          }
        }

        return {
          v: currentLocation
        };
      }();

      if (typeof _ret === "object") return _ret.v;
    } else {
      var _ret2 = function () {
        var currentLocation = identity.clampDown(location);
        var offsetRemaining = offset;

        while (offsetRemaining < 0) {
          var futureRanges = ranges.filter(function (r) {
            return r[1] < currentLocation;
          }).sort(function (a, b) {
            return b[0] - a[0];
          });

          if (futureRanges.length) {
            var nextRange = futureRanges[0];
            var delta = nextRange[1] - currentLocation;

            if (delta < offsetRemaining) {
              currentLocation = add(currentLocation, offsetRemaining);
              offsetRemaining = 0;
            } else {
              currentLocation = nextRange[0];
              offsetRemaining -= delta;
            }
          } else {
            currentLocation = add(currentLocation, offsetRemaining);
            offsetRemaining = 0;
          }
        }

        return {
          v: currentLocation
        };
      }();

      if (typeof _ret2 === "object") return _ret2.v;
    }
  };

  identity.clampUp = function (d) {
    return ranges.reduce(function (value, range) {
      return inRange(value, range) ? range[1] : value;
    }, d);
  };

  identity.clampDown = function (d) {
    return ranges.reduce(function (value, range) {
      return inRange(value, range) ? range[0] : value;
    }, d);
  };

  identity.copy = function () {
    return identity;
  };

  return identity;
};

export default provider;